var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 14.6666C2.75 17.1053 5.5 18.9386 11 20.1666C16.5 18.9444 19.25 17.111 19.25 14.6666C19.25 14.3411 19.2514 13.5683 19.2531 12.5746L19.2531 12.557L19.2531 12.5519V12.5509C19.2588 9.34349 19.2684 3.86991 19.25 3.66659C19.25 2.74992 18.3333 1.83325 17.4167 1.83325H4.58333C3.66667 1.83325 2.75 2.74992 2.75 3.66659V14.6666ZM17.4184 13.3898C17.4172 14.0699 17.4167 14.4569 17.4167 14.6666C17.4167 15.9053 15.4607 17.2445 11.0009 18.2861C6.54075 17.2399 4.58333 15.8998 4.58333 14.6666V7.33325H17.4269C17.4266 7.93111 17.426 8.57649 17.4251 9.24524C17.4243 9.86545 17.4233 10.5173 17.4221 11.2599L17.4184 13.3898ZM17.4271 5.49992H4.58333V3.66659H17.4167L17.4242 3.83225C17.4255 3.84653 17.4267 4.4894 17.4271 5.49992ZM11 10.0833C10.4937 10.0833 10.0833 9.67285 10.0833 9.16659C10.0833 8.66032 10.4937 8.24992 11 8.24992C11.5063 8.24992 11.9167 8.66032 11.9167 9.16659C11.9167 9.67285 11.5063 10.0833 11 10.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocket);
export default __webpack_public_path__ + "static/media/pocket.b0d23e029e4cf5a2af105a0e1bf85bfc.svg";
export { ForwardRef as ReactComponent };